import { render, staticRenderFns } from "./SettingsUnits.vue?vue&type=template&id=9618e702&scoped=true&"
import script from "./SettingsUnits.vue?vue&type=script&lang=js&"
export * from "./SettingsUnits.vue?vue&type=script&lang=js&"
import style0 from "./SettingsUnits.vue?vue&type=style&index=0&id=9618e702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9618e702",
  null
  
)

export default component.exports